import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/cs/501/',
    component: ComponentCreator('/cs/501/', '600'),
    exact: true
  },
  {
    path: '/cs/articles/',
    component: ComponentCreator('/cs/articles/', '1d1'),
    exact: true
  },
  {
    path: '/cs/articles/2024/07/09/diskusija-lj-nj-cyrl/',
    component: ComponentCreator('/cs/articles/2024/07/09/diskusija-lj-nj-cyrl/', '6ef'),
    exact: true
  },
  {
    path: '/cs/articles/2024/07/09/diskusija-lj-nj/',
    component: ComponentCreator('/cs/articles/2024/07/09/diskusija-lj-nj/', '52c'),
    exact: true
  },
  {
    path: '/cs/articles/archive/',
    component: ComponentCreator('/cs/articles/archive/', '044'),
    exact: true
  },
  {
    path: '/cs/articles/authors/',
    component: ComponentCreator('/cs/articles/authors/', '592'),
    exact: true
  },
  {
    path: '/cs/search/',
    component: ComponentCreator('/cs/search/', 'e3c'),
    exact: true
  },
  {
    path: '/cs/',
    component: ComponentCreator('/cs/', '013'),
    exact: true
  },
  {
    path: '/cs/',
    component: ComponentCreator('/cs/', 'edc'),
    routes: [
      {
        path: '/cs/',
        component: ComponentCreator('/cs/', '445'),
        routes: [
          {
            path: '/cs/tags/',
            component: ComponentCreator('/cs/tags/', 'f6f'),
            exact: true
          },
          {
            path: '/cs/tags/comparative/',
            component: ComponentCreator('/cs/tags/comparative/', '08b'),
            exact: true
          },
          {
            path: '/cs/tags/gramatika/',
            component: ComponentCreator('/cs/tags/gramatika/', '458'),
            exact: true
          },
          {
            path: '/cs/tags/grammar/',
            component: ComponentCreator('/cs/tags/grammar/', '610'),
            exact: true
          },
          {
            path: '/cs/tags/interslavic/',
            component: ComponentCreator('/cs/tags/interslavic/', '4fe'),
            exact: true
          },
          {
            path: '/cs/tags/language-learning/',
            component: ComponentCreator('/cs/tags/language-learning/', '2e0'),
            exact: true
          },
          {
            path: '/cs/tags/linguistics/',
            component: ComponentCreator('/cs/tags/linguistics/', 'df8'),
            exact: true
          },
          {
            path: '/cs/tags/mezislovansky-jazyk/',
            component: ComponentCreator('/cs/tags/mezislovansky-jazyk/', '98f'),
            exact: true
          },
          {
            path: '/cs/tags/mezislovanstina/',
            component: ComponentCreator('/cs/tags/mezislovanstina/', 'a04'),
            exact: true
          },
          {
            path: '/cs/tags/personal-pronouns/',
            component: ComponentCreator('/cs/tags/personal-pronouns/', '0d8'),
            exact: true
          },
          {
            path: '/cs/tags/podstatna-jmena/',
            component: ComponentCreator('/cs/tags/podstatna-jmena/', '4d3'),
            exact: true
          },
          {
            path: '/cs/tags/pronouns/',
            component: ComponentCreator('/cs/tags/pronouns/', '0f7'),
            exact: true
          },
          {
            path: '/cs/tags/slavic-languages/',
            component: ComponentCreator('/cs/tags/slavic-languages/', '332'),
            exact: true
          },
          {
            path: '/cs/tags/srovnani-jazyku/',
            component: ComponentCreator('/cs/tags/srovnani-jazyku/', 'bf1'),
            exact: true
          },
          {
            path: '/cs/tags/studium-jazyka/',
            component: ComponentCreator('/cs/tags/studium-jazyka/', '813'),
            exact: true
          },
          {
            path: '/cs/tags/uceni-jazyka/',
            component: ComponentCreator('/cs/tags/uceni-jazyka/', 'a06'),
            exact: true
          },
          {
            path: '/cs/tags/uceni-se-jazyka/',
            component: ComponentCreator('/cs/tags/uceni-se-jazyka/', 'c81'),
            exact: true
          },
          {
            path: '/cs/tags/zajmena/',
            component: ComponentCreator('/cs/tags/zajmena/', 'c80'),
            exact: true
          },
          {
            path: '/cs/',
            component: ComponentCreator('/cs/', 'e39'),
            routes: [
              {
                path: '/cs/learn/faq/',
                component: ComponentCreator('/cs/learn/faq/', 'f94'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/grammar/',
                component: ComponentCreator('/cs/learn/grammar/', '16c'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/grammar/adjectives/',
                component: ComponentCreator('/cs/learn/grammar/adjectives/', '4d8'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/grammar/conjunctions/',
                component: ComponentCreator('/cs/learn/grammar/conjunctions/', '66d'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/grammar/nouns/',
                component: ComponentCreator('/cs/learn/grammar/nouns/', '584'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/grammar/numerals/',
                component: ComponentCreator('/cs/learn/grammar/numerals/', '8b9'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/grammar/prepositions/',
                component: ComponentCreator('/cs/learn/grammar/prepositions/', '578'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/grammar/pronouns/',
                component: ComponentCreator('/cs/learn/grammar/pronouns/', '1c6'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/grammar/syntax/',
                component: ComponentCreator('/cs/learn/grammar/syntax/', 'f07'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/grammar/verbs/',
                component: ComponentCreator('/cs/learn/grammar/verbs/', 'd5e'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/introduction/',
                component: ComponentCreator('/cs/learn/introduction/', '90b'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/misc/constructed-slavic-languages/',
                component: ComponentCreator('/cs/learn/misc/constructed-slavic-languages/', 'e41'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/misc/design-criteria/',
                component: ComponentCreator('/cs/learn/misc/design-criteria/', '7f7'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/misc/history/',
                component: ComponentCreator('/cs/learn/misc/history/', 'd6d'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/misc/language-comparison/',
                component: ComponentCreator('/cs/learn/misc/language-comparison/', '403'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/misc/numbers-1-10/',
                component: ComponentCreator('/cs/learn/misc/numbers-1-10/', '339'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/misc/pan-slavic-relay/',
                component: ComponentCreator('/cs/learn/misc/pan-slavic-relay/', '131'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/misc/personal-pronouns/',
                component: ComponentCreator('/cs/learn/misc/personal-pronouns/', '47d'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/orthography/',
                component: ComponentCreator('/cs/learn/orthography/', '0a7'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/phonology/',
                component: ComponentCreator('/cs/learn/phonology/', '642'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/pronunciation/',
                component: ComponentCreator('/cs/learn/pronunciation/', 'cdb'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/simple-grammar/',
                component: ComponentCreator('/cs/learn/simple-grammar/', '9bb'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/simple-grammar/level-1/',
                component: ComponentCreator('/cs/learn/simple-grammar/level-1/', '6bd'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/simple-grammar/level-2/',
                component: ComponentCreator('/cs/learn/simple-grammar/level-2/', '541'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/vocabulary/derivation/',
                component: ComponentCreator('/cs/learn/vocabulary/derivation/', '914'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/vocabulary/flavourisation/',
                component: ComponentCreator('/cs/learn/vocabulary/flavourisation/', 'a23'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/learn/vocabulary/word-formation/',
                component: ComponentCreator('/cs/learn/vocabulary/word-formation/', '933'),
                exact: true,
                sidebar: "learnSidebar"
              },
              {
                path: '/cs/resources/',
                component: ComponentCreator('/cs/resources/', 'ce8'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/cs/resources/applets/',
                component: ComponentCreator('/cs/resources/applets/', 'dc2'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/cs/resources/applets/intelligibility/',
                component: ComponentCreator('/cs/resources/applets/intelligibility/', 'c35'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/cs/resources/applets/transliterator/',
                component: ComponentCreator('/cs/resources/applets/transliterator/', '55d'),
                exact: true,
                sidebar: "resourcesSidebar"
              },
              {
                path: '/cs/resources/keyboards/',
                component: ComponentCreator('/cs/resources/keyboards/', 'f4e'),
                exact: true,
                sidebar: "resourcesSidebar"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
